'use strict'
var login = angular.module('loginModule',['ui.router','servicesModule']);
require('./directive/loginDirective.js')(login);
require('./loginController.js')(login);


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/loginModule/js/loginModule.js
// module id = 505
// module chunks = 0